export default __webpack_public_path__ + "locales/sk/About.json?hash=f15b5fbf9a0cba4b45dc50f5c7d8332b";